export default __webpack_public_path__ + "fa0317f33755f2d55fa96ad85fa8d38e.png";